var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArticle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0v15c0 1.646 1.354 3 3 3h12c1.646 0 3-1.354 3-3V4.5h-4.5V0H0Zm1.5 1.5H12V15c0 .55.164 1.055.422 1.5H3c-.838 0-1.5-.662-1.5-1.5V1.5Zm1.5 3V6h7.5V4.5H3ZM13.5 6h3v9c0 .838-.662 1.5-1.5 1.5s-1.5-.662-1.5-1.5V6ZM3 7.5V9h3V7.5H3Zm4.5 0V9h3V7.5h-3Zm-4.5 3V12h3v-1.5H3Zm4.5 0V12h3v-1.5h-3Zm-4.5 3V15h3v-1.5H3Zm4.5 0V15h3v-1.5h-3Z",
  fill: "#111"
})));
export default SvgArticle;